var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forget-4"},[_c('card',{staticClass:"card"},[_c('img',{staticClass:"img-done",attrs:{"src":require("assets/img/auth/img_done.png"),"alt":""}})]),_c('div',{staticClass:"btns"},[_c('div',{staticClass:"btn",on:{"click":_vm.actionLogin}},[_c('span',[_vm._v(_vm._s(_vm.$t.auth.backLogin))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }